import React, { useState } from 'react'

import NewEnrollmentPredictors from './components/NewEnrollmentPredictors'
import FiltersListForPrintView from './components/FiltersListForPrintView'
import Layout from './components/Layout'
import Sidebar from './components/Sidebar'
import { Tab, Tabs } from './components/Tabs'
import Trends from './components/Trends'

const initialFilters = {
  studentType: '',
  sex: '',
  alabama: '',
  raceEthnicity: '',
  college: '',
  distanceLearning: '',
  highSchoolState: '',
  priorCollegeState: '',
  collegeType: '',
}

function App() {
  const [filters, setFilters] = useState(initialFilters)
  const [filterOptions, setFilterOptions] = useState(null)
  const [residency, setResidency] = useState('All')

  const handleInput = React.useCallback(
    event => {
      if (event === true) {
        // special case: clear all
        return setFilters(initialFilters)
      }
      // toggle case
      let value = event.target.value
      if (value==='on') value = filters[event.target.name] ? '' : true
      if (value==='off') value = ''
      // clear college/school on type changes
      const other = {}
      if (event.target.name==='studentType') {
        other['priorCollegeState'] = ''
        other['highSchoolState'] = ''
        other['highSchoolCounty'] = ''
        other['priorCollegeCounty'] = ''
      }
      setFilters({
        ...filters,
        [event.target.name]: value,
        ...other,
      })
    },
    [filters]
  )

  const handleResidency = React.useCallback(
    event => setResidency(event.target.value),
    []
  )

  return (
    <Layout>
      <Sidebar
        filters={filters}
        filterValues={filterOptions}
        handleInput={handleInput}
        handleResidency={handleResidency}
        residency={residency}
      />
      <main className="main">
        <Tabs>
          <Tab
            title="Summary"
            render={() => (
              <div className="main-header">
                <h2>Summary</h2>
                <FiltersListForPrintView
                  filters={filters}
                  residency={residency}
                />
                <div>
                  <NewEnrollmentPredictors
                    filters={filters}
                    setFilterOptions={setFilterOptions}
                  />
                </div>
              </div>
            )}
          />
          <Tab
            title="Trend"
            render={() => (
              <div className="main-header">
                <Trends
                  filters={filters} 
                  setFilterOptions={setFilterOptions}
                />
              </div>
            )}
          />
        </Tabs>
      </main>
    </Layout>
  )
}

export default App
